<template>
  <div
    v-if="provider"
    class="fulfiller-info"
  >
    <p class="fulfiller-info__provider">
      <LinkButton
        v-if="hasBrodosInfo"
        tag="button"
        data-tealium-rel="content.text.hier"
        text
        no-styling
        @click="openBrodosModal"
      >
        Verkauf und Versand durch {{ originDisplayName }}.
      </LinkButton>

      <span v-else> Verkauf und Versand durch {{ originDisplayName }}.</span>
      <template v-if="isFreightForwardingService">
        Kostenfreie Speditionslieferung durch Rhenus Home Delivery nach individueller
        Terminabsprache.
      </template>
    </p>

    <p v-if="hasBrodosInfo">
      <NuxtLink
        to="/weitere-informationen/ueber-brodos"
        data-tealium-rel="content.text.hier"
        class="link"
      >
        Informationen zum Bestellablauf.
      </NuxtLink>
    </p>
    <p v-if="hasTelekomInfo">
      <LinkButton
        tag="button"
        data-tealium-rel="content.text.hier"
        text
        no-styling
        @click="openTelekomModal"
      >
        Informationen zum Bestellablauf.
      </LinkButton>
    </p>
  </div>
</template>

<script setup lang="ts">
import { computed, defineAsyncComponent, markRaw, type PropType } from 'vue';
import type { ProductProviderKey } from '~/lib/goliath/goliath.types';
import { LinkButton } from '@i22/td-longtail-vue-components';
import { openModal } from '~/composables/modal';
import { getProvider } from '~/lib/providers';

const props = defineProps({
  provider: { type: String as PropType<ProductProviderKey>, required: true },
  isFreightForwardingService: { type: Boolean },
});

const hasBrodosInfo = computed(() => props.provider === 'BRODOS');
const hasTelekomInfo = computed(() => props.provider === 'TELEKOM');
const originDisplayName = computed(() => getProvider(props.provider));

const openBrodosModal = () => {
  openModal({
    closeOnBackdrop: true,
    heading: 'Brodos AG',
    component: {
      is: markRaw(defineAsyncComponent(() => import('~/components/brodos-info-modal.vue'))),
    },
  });
};

const openTelekomModal = () => {
  openModal({
    closeOnBackdrop: true,
    heading: 'Informationen zum Bestellablauf',
    component: {
      is: markRaw(defineAsyncComponent(() => import('~/components/telekom-info-modal.vue'))),
    },
  });
};
</script>

<style lang="scss" scoped>
@use 'assets/base' as *;

.fulfiller-info {
  p {
    @include font-size(15px, 20px);
    margin-bottom: 3px; // add space to get the 24px height (WCAG 2.5.8)
  }
  &__provider {
    padding: 0;
    margin: 0;
  }
}
</style>
